import { render, staticRenderFns } from "./GerenciamentoTransporteExportacao.vue?vue&type=template&id=a10b761e"
import script from "./GerenciamentoTransporteExportacao.vue?vue&type=script&lang=js"
export * from "./GerenciamentoTransporteExportacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports